module.exports = __webpack_public_path__ + "img/share.f281b529.png";